"use client";

// [RUDDERSTACK-OLD disabled 2026-07-20] widget_viewed → now central widget_impression
// (TrackedWidget in NewPage); see webapp/docs/analytics
// import { FireWidgetViewedEvent } from "@/customAnalytics/trackingEvents";
import { cn } from "@/lib/utils";
import { useRef } from "react";

export default function BlogInlineImage1({ data }: { data: any }) {
  const ref = useRef<HTMLElement | null>(null);
  const sectionData = data?.data ?? data;

  // [RUDDERSTACK-OLD disabled 2026-07-20] impression now central; see webapp/docs/analytics
  // useEffect(() => {
  //   if (ref.current) {
  //     FireWidgetViewedEvent(ref, "blog_inline_image_section");
  //   }
  // }, []);

  const isActive =
    sectionData?.status === true ||
    sectionData?.status === 1 ||
    sectionData?.status === "1";

  const desktopRaw = String(sectionData?.image_url ?? "").trim();
  const mobileRaw = String(sectionData?.mobile_image_url ?? "").trim();
  const desktopSrc = desktopRaw || mobileRaw;
  const mobileSrc = mobileRaw || desktopRaw;

  if (!isActive || !desktopSrc) {
    return null;
  }

  const alt = String(sectionData?.alt_text ?? "").trim() || "Blog image";
  const caption = String(sectionData?.caption ?? "").trim();
  const captionColor = sectionData?.caption_text_color ?? "#737373";
  const alignment = String(
    sectionData?.caption_alignment ?? "left",
  ).toLowerCase();
  const rawRadius = Number(sectionData?.border_radius_px ?? 8);
  const radius = Number.isFinite(rawRadius)
    ? Math.max(0, Math.min(48, rawRadius))
    : 8;

  const alignClass =
    alignment === "center"
      ? "text-center"
      : alignment === "right"
        ? "text-right"
        : "text-left";

  const imgClass =
    "h-auto w-full max-w-full object-cover";

  const useSingleAsset = desktopSrc === mobileSrc;

  return (
    <figure ref={ref} className="w-full min-w-0">
      {useSingleAsset ? (
        <img
          src={desktopSrc}
          alt={alt}
          className={imgClass}
          style={{ borderRadius: `${radius}px` }}
          loading="lazy"
          decoding="async"
        />
      ) : (
        <>
          <img
            src={mobileSrc}
            alt={alt}
            className={cn(imgClass, "sm:hidden")}
            style={{ borderRadius: `${radius}px` }}
            loading="lazy"
            decoding="async"
          />
          <img
            src={desktopSrc}
            alt={alt}
            className={cn(imgClass, "hidden sm:block")}
            style={{ borderRadius: `${radius}px` }}
            loading="lazy"
            decoding="async"
          />
        </>
      )}
      {caption ? (
        <figcaption
          className={cn(
            "mt-2 text-xs font-normal leading-relaxed sm:text-sm",
            alignClass,
          )}
          style={{ color: captionColor }}
        >
          {caption}
        </figcaption>
      ) : null}
    </figure>
  );
}
